module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Tour continues on next screen","content":"Please complete writing your text message broadcast. Your tour will automatically continue on the next screen.","okGotIt":"Ok, got it"}}')
  delete Component.options._Ctor
}
